'use client'
import useOnScreen from '@hooks/useOnScreen'
import { Fade } from '@mui/material'
import React, { useRef } from 'react'

export default function YouTubeCard() {
  const root = useRef()
  const isVisible = useOnScreen(root)

  return (
    <div ref={root}>
      <Fade in={isVisible} timeout={2000}>
        <div className="w-full max-w-4xl mx-auto bg-dark-8 border-[1px] border-dark-6 rounded-xl shadow-lg overflow-hidden">
          <div className="p-6">
            <div className="relative w-full pb-[56.25%]">
              <iframe
                src="https://www.youtube.com/embed/ZsHraPrDaDM?start=0"
                title="We Are DeWicats"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full rounded-lg"
              />
            </div>
          </div>
        </div>
      </Fade>
    </div>
  )
}
